export default {
    init: function (el) {
        el.addEventListener('touchstart', callback, {passive:false});
    },
    destroy: function(el) {
        el.removeEventListener('touchstart', callback, {passive:false});
    }
};

function callback(event) {
    if (event.touches && event.touches.length > 1) {
        event.preventDefault();
    }
}